import React, {useMemo} from "react"
import StackedDonutBase from "./Charts/stacked-donut-base"
import {numberToDeNumberString} from "../../misc/utils"


//Kompnente braucht ein Rework des Dateninputs.
//Hier wird auch gerechnet. Das sollte so nicht gemacht werden. Die Datensätze müssen vollständig aus der Action kommen.
const ChartDonutWidget = ({value, widget}) => {
    const {data = {}, labels = []} = value ?? {}
    const {valSecondary = 0, valPrimary = 0, valTertiary = 0, hex = "#000000"} = data

    const percentage = useMemo(() => {
        const result = Math.floor((1 - valSecondary / (valSecondary + valPrimary + valTertiary)) * 100)
        return Number.isNaN(result) ? 0 : result
    }, [valSecondary, valPrimary, valTertiary])

    const datasets = useMemo(() => [
        {
            label: "",
            backgroundColor: [hex, "#666666", "#D62828"],
            data: [valPrimary, valTertiary, valSecondary],
            formattedValue: [
                `${numberToDeNumberString(valPrimary)} €`,
                `${numberToDeNumberString(valTertiary)} €`,
                `${numberToDeNumberString(valSecondary)} €`,
            ],
        },
    ], [hex, valPrimary, valTertiary, valSecondary])

    return <StackedDonutBase datasets={datasets}
                             labels={labels}
                             centerTitle={`${percentage}%`}
                             height={Number.parseInt(widget?.maxHeight)} />
}
export default ChartDonutWidget
